import { Skeleton, Stack } from "@mui/material";

export const PartsListLoading = () => {
  return (
    <Stack gap={2} p={2}>
      {Array(4)
        .fill(null)
        .map((_, index) => {
          return <Skeleton key={index} height={40} />;
        })}
    </Stack>
  );
};
